import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isYandexMetrikaInitialized, yandexMetrikaHit } from '../lib/yandexMetrika';

/** Виртуальные просмотры при навигации React Router (SPA), только после init Метрики. */
const YandexMetrikaHitTracker = () => {
  const location = useLocation();
  const skipFirstHit = useRef(true);

  useEffect(() => {
    if (!isYandexMetrikaInitialized()) return;
    if (skipFirstHit.current) {
      skipFirstHit.current = false;
      return;
    }
    const url = `${location.pathname}${location.search}${location.hash}`;
    yandexMetrikaHit(url, { title: document.title });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default YandexMetrikaHitTracker;
